import { bool, func, arrayOf, number, oneOfType, shape, string } from "prop-types";
import AiProvider from "@shared/AiAssistant/AiProvider";
import { lazyAiComponent } from "@shared/AiAssistant/lazyAiComponent";
import { ContactShape } from "../listing_alerts/helper";

const SendMailModal = lazyAiComponent("SendMailModal");

const SelectMailerTypeModal = ({
  isModalOpen = false,
  setOpen = () => {},
  personData = [],
  smartFilter = null,
}) => (
  <AiProvider>
    <SendMailModal open={isModalOpen} setOpen={setOpen} contacts={personData} smartFilter={smartFilter} />
  </AiProvider>
);

SelectMailerTypeModal.propTypes = {
  isModalOpen: bool,
  setOpen: func,
  personData: arrayOf(ContactShape),
  smartFilter: shape({
    // A saved Smart Filter uses its numeric id; the unfiltered "All People" selection uses "allPeople".
    id: oneOfType([number, string]).isRequired,
    name: string.isRequired,
    recipientCount: number.isRequired,
  }),
};

export default SelectMailerTypeModal;
